import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { readFactoryContractList } from '@/api/asset/factory/read';
import { PoolType } from '@/types';

export default function SelectFactoryContract({ setPools }: { setPools: (value: any) => void }) {
  const [list, setList] = useState<string[] | null>(null);
  const [value, setValue] = useState('');
  useEffect(() => {
    (async () => {
      const re = await readFactoryContractList();
      console.log(re);
      if (re.status !== 200) {
        return;
      }
      setList(re.data);
    })();
    return () => {};
  }, []);

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value as string);
    setPools((prev: PoolType) => ({
      ...prev,
      factoryId: event.target.value as string,
    }));
  };

  return (
    <>
      {list && (
        <Box sx={{ minWidth: 120 }}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Factory Contract List</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={value}
              label="list"
              onChange={handleChange}
            >
              {list.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
    </>
  );
}
